import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Location } from '@angular/common';

import { OAuthService } from '../services/oauth.service';

@Injectable()

export class LoggedInGuard implements CanActivate {

  constructor(private router: Router, private _location: Location) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (OAuthService.getAccessToken()) {
      this.router.navigate(['']);
    }
    return !!!OAuthService.getAccessToken();
  }
}
